import { FaqItemData } from '~/landingV4/types/faq.types'

export const faqs: FaqItemData[] = [
  { answerKey: 'v4.faq.q1.answer', defaultExpanded: true, questionKey: 'v4.faq.q1.question' },
  { answerKey: 'v4.faq.q2.answer', questionKey: 'v4.faq.q2.question' },
  { answerKey: 'v4.faq.q3.answer', questionKey: 'v4.faq.q3.question' },
  { answerKey: 'v4.faq.q4.answer', questionKey: 'v4.faq.q4.question' },
  { answerKey: 'v4.faq.q5.answer', questionKey: 'v4.faq.q5.question' },
]
